export default "__VITE_PUBLIC_ASSET__10fb5008__"